import React, { Component } from 'react';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Icon from '../../partials/Icon';
import Moment from 'react-moment';
import Message from '../../partials/Message';
import Errors from '../../partials/Errors';
import 'moment/locale/sv';

export default class Project extends Component {
    state = {
        isOpen: false,
        been_payed: '',
        payed: false
    }

    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentWillMount() {
        this.setState({ 
            been_payed: (this.props.project.been_payed ? this.props.project.been_payed : ''),
            payed: (this.props.project.been_payed ? true : false)
        });
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ 
            been_payed: (nextProps.project.been_payed ? nextProps.project.been_payed : ''),
            payed: (nextProps.project.been_payed ? true : false)
        });
    }

    inputChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    toggleForm(event) {
        event.preventDefault();
        this.state.isOpen ? this.setState({ isOpen: false }) : this.setState({ isOpen: true });
    }

    submit(event) {
        event.preventDefault();

        axios.put(API_URL+'/admin/sales/'+this.props.project.id, {
            been_payed: this.state.been_payed
        })
        .then(response => {
            this.props.update();
            this.setState({ 
                message: 'Ändringen sparades.',
                payed: this.state.been_payed ? true : false
            });
        })
        .catch(error => {
            this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
        });
    }

    render() {
        const { project } = this.props;
        
        return (
            <li>
                { this.state.payed ? (
                    <Icon key="1" icon="payed" title="Har fått betalt" />
                ) : (
                    <Icon key="2" icon="not-payed" title="Har inte fått betalt" />
                ) }

                <span className="regular-text wrapper pointer" onClick={ this.toggleForm }>
                    <span className="right small">
                        <Moment locale="sv" format="D/M">{ project.start_date }</Moment><br /><Moment locale="sv" format="D/M">{ project.end_date }</Moment>
                    </span>

                    { project.group && project.group.school ? (
                        <span>{ project.group.name }, { project.group.school.name }</span>
                    ) : (
                        <span><i>Grupp borttagen</i></span>
                    ) }
                    <br /><small>Sålt { project.sold ? project.sold : '0' } av { project.shares }</small>
                    { project.project ? (
                        <small>, { project.project.title }</small>
                    ) : (
                        <small>, <i>Projekt borttaget</i></small>
                    ) }
                </span>

                <div className={ this.state.isOpen ? '' : 'hidden' }>
                    <Errors errors={ this.state.errors } />
                    <Message message={ this.state.message} />

                    <form onSubmit={ this.submit }>
                        <label>Utbetalningsdatum (YYYY-MM-DD)</label>
                        <input type="text" name="been_payed" placeholder="Utbetalningsdatum" value={ this.state.been_payed } onChange={ this.inputChange } />
                        <input className="button purple" type="submit" value="Spara" />
                    </form>
                </div>
            </li>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/superadmin/Sales/Project.js